<ng-container *transloco="let t;">
<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1"> <h4 class="modal-title" id="myModalLabel1">{{ exportFormat === 'csv' ? t('Modal title (Contract Control Export CSV) - Export CSV') : t('Export XLSX menu item (documents three dots menu) - Export XLSX') }}</h4></h4>
    <button type="button" class="close" aria-label="Close" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body p-0" tabindex="0" ngbAutofocus>
    <div>
        <div class="row" id="table-hover-row">
            <div class="col-12">
                <div class="card m-0 pt-1">
                    <ng-template #emptyExport>
                        {{ t('No items notification (Contract Control Export CSV) - Nothing to export') }}
                    </ng-template>
                    @if(loading){
                        <app-skeleton [loop]="8" [section]="'export-Loader'"></app-skeleton>
                    } @else {
                        <app-table [columns]="columns" [data]="items" [emptyDataTemplate]="emptyExport" ></app-table>
                        @if (pageOptions){
                            <app-table-pager [pagerOptions]="pageOptions"
                                             (pageChange)="onPageChange($event)"></app-table-pager>
                        }
                    }
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" rippleEffect (click)="dismissModal()">
        {{t('Cancel button (Contract Control Export CSV) - Cancel')}}
    </button>
    <button type="button" class="btn btn-success" rippleEffect (click)="onDownloadClick()">
        {{t('Download button (Contract Control Export CSV) - Download')}} {{ exportFormat | uppercase }}
    </button>
</div>
</ng-container>
